import React from "react";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import ButtonRounded from "../../../../../../components/ButtonRounded";
import IndicatorBox from "../../../../../../containers/card/multiStep/IndicatorBoxContainer";
import EditableTableContainer from "../../../../../../containers/card/multiStep/EditableTableContainer";
import MatchingTablesContainer from "../../../../../../containers/card/multiStep/MatchingTablesContainer";
import OverviewPanel from "./OverviewPanel";
import OverviewTableConstructionContainer from "../../../../../../containers/card/multiStep/OverviewTableConstructionContainer";
import { useMainCardStyles } from "../../../../../../common/styles/cardStyles";

const useStyles = useMainCardStyles;

interface CardEditableTableProps {
  step: number;
  handleNext: () => void;
  handleBack: () => void;
}

const CardEditableTable: React.FC<CardEditableTableProps> = ({
  step,
  handleBack,
  handleNext,
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid
          container
          alignItems="center"
          justify="space-between"
          className={classes.btnContainer}
        >
          <Grid item>
            <IndicatorBox />
          </Grid>
          <Grid item>
            {step > 0 && (
              <ButtonRounded
                variant="contained"
                className={clsx(classes.btn, classes.btnDark)}
                onClick={handleBack}
              >
                Back
              </ButtonRounded>
            )}
            <ButtonRounded
              variant="contained"
              color="primary"
              className={classes.btn}
              onClick={handleNext}
            >
              Next
            </ButtonRounded>
          </Grid>
        </Grid>

        {step === 4 ? <MatchingTablesContainer /> : <EditableTableContainer />}

        <OverviewPanel className={classes.overviewPanel}>
          <OverviewTableConstructionContainer />
        </OverviewPanel>
      </CardContent>
    </Card>
  );
};

export default CardEditableTable;
